module.exports = __webpack_public_path__ + "static/media/lumen_games.4242de6e.png";